<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Header  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Master Data</li>
                <li class="breadcrumb-item">Master Budget Type</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>

      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <!-- Tab Header -->
            <div class="tabs-header">
              <b-nav pills>
                <b-nav-item
                  v-for="(tab, index) in tabs"
                  :key="index"
                  :active="activeTab === tab.name"
                  @click="activeTab = tab.name"
                >
                  {{ tab.title }}
                </b-nav-item>
              </b-nav>
            </div>
          </div>
        </div>
      </div>

      <!-- Dinamis Body Tab -->
      <div class="tabs-body mt-3">
        <component :is="activeTabComponent"></component>
      </div>
    </div>
  </div>

</template>

<script>
import FundCenter from "../fund-center.vue";
import Fund from "../fund.vue";
import TransactionType from "../tt-account.vue";
import BudgetItem from "../tt-budgetItem.vue";
import OpexGl from "../opex-gl.vue";
import CapexGl from "../capex-gl.vue";

export default {
  name: "MasterBudgetType",
  data() {
    return {
      activeTab: "FundCenter",
      tabs: [
        { name: "FundCenter", title: "Fund Center" },
        { name: "Fund", title: "Fund" },
        { name: "TransactionType", title: "Transaction Type" },
        { name: "BudgetItem", title: "Budget Item" },
        { name: "OpexGl", title: "OPEX GL" },
        { name: "CapexGl", title: "CAPEX GL" },
      ],
    };
  },
  computed: {
    activeTabComponent() {
      return this.activeTab;
    },
  },
  components: {
    FundCenter,
    Fund,
    TransactionType,
    BudgetItem,
    OpexGl,
    CapexGl,
  },
};
</script>

<style scoped>
/* Styling khusus untuk header tab */
.tabs-header {
  /* Opsional, jika ingin jarak di antara tab lebih lebar */
}

/* Target elemen .nav-link dalam b-nav pills */
.tabs-header .nav-pills .nav-link {
  color: #777;               /* Warna teks default tab */
  background-color: transparent;
  border-radius: 0;          /* Hilangkan efek pill (rounded) */
  margin-right: 20px;        /* Spasi antar tab */
  border: none;              /* Hilangkan border bawaan */
}

/* Hover state (opsional) */
.tabs-header .nav-pills .nav-link:hover {
  color: #000;               /* Ganti warna teks saat hover */
}

/* Tab aktif: bold + underline merah */
.tabs-header .nav-pills .nav-link.active {
  color: #000;               /* Warna teks tab aktif */
  font-weight: bold;         /* Teks tebal */
  background-color: transparent;
  border-bottom: 2px solid #AF0404; /* Garis bawah merah */
  border-radius: 0;
}
</style>
